import React from 'react'
import Forstartupshero from '../components/forstartupshero/forstartupshero'
import Startupservices from '../components/startupservices/startupservices'
import Expertise from '../components/expertise/expertise'
import Engagement from '../components/engagementmodels/engagement'
import Specially from '../components/specially/specially'
import Talktous from '../components/talktous/talktous'
import Connectwithus from '../components/connectwithus/connectwithus'
import Footer from '../components/footer/footer'
import Agenciespractise from '../components/agenciespractices/agenciespractise'
import Agenciesfeatures from '../components/agenciesfeatures/agenciesfeatures'



function Foragencies() {

  return (
    <div className='foragencies'>
      <Forstartupshero />
      <Startupservices defaultTab={2} />
      <Agenciespractise />
      <Agenciesfeatures />
      <Expertise />
      <Engagement />
      <Specially />
      <Talktous />
      <Connectwithus />
      <Footer />
    </div>
  )
}

export default Foragencies